export function fitFontSize({
  measure,
  available,
  max,
  min = 14,
  current,
  slack = 0,
}: {
  measure: (px: number) => number;
  available: number;
  max: number;
  min?: number;
  /** The size applied now. A grow beyond it must fit in `available - slack`. */
  current?: number | undefined;
  /** The classic scrollbar's width, 0 where scrollbars overlay. */
  slack?: number;
}): number {
  const largest = (room: number) => {
    for (let px = max; px > min; px -= 1) {
      if (measure(px) <= room) return px;
    }
    return min;
  };
  const px = largest(available);
  if (current === undefined || px <= current) return px;
  // A grow must fit in `available - slack`, so a scrollbar toggled by the header's own
  // height cannot flip the size back and forth. Cost: after a resize the size can lag a
  // fresh fit by up to one scrollbar width, until a font load, team switch or larger widen.
  return Math.max(current, largest(available - slack));
}
